export interface dashboardSummaryParams {
  startDate?: number
  endDate?: number
  domains?: Array<string>
  campaigns?: Array<string>
  timezone: string | null
  platforms?: Array<string>
}

export interface DashboardSummaryDataEntry {
  unixTimestamp?: number
  protectedVisits?: number
  protectedValidVisits?: number
  whiteListed?: number
  visits: number
  invalid: number
  threatGroup?: string
  threatType?: string
  campaign?: string
  keyword?: string
  country?: string
  blockedCookies?: number
  directTraffic?: number
  directInvalidTraffic?: number
  paidTraffic?: number
  paidInvalidTraffic?: number
  organicTraffic?: number
  organicInvalidTraffic?: number
  domain: string
  ip: number
  cBlock: number
}

export type ThreatGroupBreakdownData = {
  threatGroup: string
  threatType: string
  invalid: number
  total: number
}

export class VisitsSummary {
  visits: number
  paidInvalidTraffic: number
  organicInvalidTraffic: number
  directInvalidTraffic: number
  paidTraffic: number
  organicTraffic: number
  directTraffic: number
  constructor(
    visits = 0,
    paidInvalidTraffic = 0,
    organicInvalidTraffic = 0,
    directInvalidTraffic = 0,
    paidTraffic = 0,
    organicTraffic = 0,
    directTraffic = 0
  ) {
    this.visits = visits
    this.paidInvalidTraffic = paidInvalidTraffic
    this.organicInvalidTraffic = organicInvalidTraffic
    this.directInvalidTraffic = directInvalidTraffic
    this.paidTraffic = paidTraffic
    this.organicTraffic = organicTraffic
    this.directTraffic = directTraffic
  }
}

export type AccountPlanData = {
  botZappingAllowed: boolean
  botZappingVisitsLimit?: number
  botZappingDomainsLimit?: number
  paidMarketingAllowed: boolean
  paidMarketingVisitsLimit?: number
  paidMarketingDomainsLimit?: number
}

export type GetDashboardSummaryResponse = {
  trends: DashboardSummaryDataEntry
  data: Array<DashboardSummaryDataEntry>
  totals: DashboardSummaryDataEntry
}

export type BotzappingDomainSummary = {
  blockedPageloads: number
  blockedSiteInteractions: number
  domain: string
  invalidRate: number
  protectedValidVisitsPercentage: number
  protectedVisits: number
  protectedValidVisits: number
  totalVisits: number
  whiteListed: number
  totalBlocked: number
  whiteListedPercentage: number
}

export interface BotzappingDatedSummary extends BotzappingDomainSummary {
  date: string
  totalBlocked: 0
}

export type BottzappingInsight = {
  domain: string
  invalidRate: number
  threatGroup: string
  threatType: string
  totalBlocked: number
}

export type BotzappingDataResponse = {
  summary: {
    total: {
      totalBlocked: number
      blockedPageloads: number
      blockedSiteInteractions: number
      invalidRate: number
      protectedValidVisitsPercentage: number
      protectedVisits: number
      totalVisits: number
      whiteListed: number
      whiteListedPercentage: number
    }
    summary: Array<BotzappingDomainSummary> | null
  }
  datedSummaries: Array<BotzappingDatedSummary>
  insights: Array<BottzappingInsight>
}

export class TrendsData {
  timestamp: number
  invalid: number
  total: number
  invalidRate: number
  constructor(timestamp = 0, invalid = 0, total = 0, invalidRate = 0) {
    this.timestamp = timestamp
    this.invalid = invalid
    this.total = total
    this.invalidRate = invalidRate
  }
}

export interface DomainsInvalidRateData {
  domainAddress: string
  domainId: number
  paidInvalidTraffic: number
  totalPaidTraffic: number
}

export type ThreatGroupDrillDownPart = {
  type: 'pie'
  name: string
  id: string
  dataObj: { [key: string]: number }
  data: [string, number][]
}

export class ThreatGroupData {
  name: string
  y: number
  color: string
  drilldown: string
  drilldownData: ThreatGroupDrillDownPart
  constructor(name: string, color: string) {
    this.name = name
    this.y = 0
    this.drilldown = name
    this.drilldownData = {
      type: 'pie',
      name,
      id: name,
      data: [],
      dataObj: {},
    } as ThreatGroupDrillDownPart
    this.color = color
  }
}

export type NewThreatGroupBreakdownData = {
  threatGroup: string
  threatType: string
  invalid: number
  total: number
}

export type NewTrendsData = {
  timestamp: number
  invalid: number
  total: number
  invalidRate: number
}

export type NewBlockingActivity = {
  ip: number
  cBlock: number
  cookies: number
  events: number
  facebookCookies: number
  googleCookies: number
  microsoftCookies: number
  accountLevelBlocking: boolean
}
